import BreezeEmailSupportModalHost from './BreezeEmailSupportModalHost';
import BreezeImageLightboxModalHost from './BreezeImageLightboxModalHost';
import BreezeProjectsModalHost from './BreezeProjectsModalHost';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BreezeModalHost = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(BreezeEmailSupportModalHost, {}), /*#__PURE__*/_jsx(BreezeImageLightboxModalHost, {}), /*#__PURE__*/_jsx(BreezeProjectsModalHost, {})]
});
export default BreezeModalHost;